import { useCallback, useContext } from 'react';
import ScreenTrackingContext from 'automation-ui-usage-tracking/ScreenTrackingContext';
import SubscreenTrackingContext from 'automation-ui-usage-tracking/SubscreenTrackingContext';
import UsageTrackerContext from 'automation-ui-usage-tracking/UsageTrackerContext';
import { trackEvent, trackPageView } from 'automation-ui-usage-tracking/trackingUtils';
export const useTrackEvent = () => {
  const {
    usageTracker,
    immediateUsageTracker
  } = useContext(UsageTrackerContext);
  const screen = useContext(ScreenTrackingContext);
  const subscreen = useContext(SubscreenTrackingContext);
  const _trackEvent = useCallback((trackableKey, extraJSON = {}, immediate = false) => {
    const screenTrackingData = {};
    if (screen) {
      screenTrackingData.screen = screen;
    }
    if (subscreen) {
      screenTrackingData.subscreen = subscreen;
    }
    return trackEvent(immediate ? immediateUsageTracker : usageTracker, trackableKey, Object.assign({}, screenTrackingData, extraJSON));
  }, [immediateUsageTracker, usageTracker, screen, subscreen]);
  return _trackEvent;
};
export const useTrackPageView = () => {
  const {
    usageTracker
  } = useContext(UsageTrackerContext);
  const contextScreen = useContext(ScreenTrackingContext);
  const contextSubscreen = useContext(SubscreenTrackingContext);
  const _trackPageView = useCallback(({
    screen,
    subscreen
  }, extraJSON = {}) => {
    const screenTrackingData = {};
    if (screen) {
      screenTrackingData.screen = screen;
    } else if (contextScreen) {
      screenTrackingData.screen = contextScreen;
    }
    if (subscreen) {
      screenTrackingData.subscreen = subscreen;
    } else if (contextSubscreen) {
      screenTrackingData.subscreen = contextSubscreen;
    }
    return trackPageView(usageTracker, screenTrackingData, extraJSON);
  }, [usageTracker, contextScreen, contextSubscreen]);
  return _trackPageView;
};